import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class RelatedJobBus extends BaseBus
{
  CID(): any {
      return this.relatedJobId;
  }
    constructor(data: RelatedJobBus) {
        super(data);
    }
    initialize(data: RelatedJobBus) {
        super.initialize(data);
        this.insertDt = DateFunctions.getDate(data.insertDt);
        this.updateDt = DateFunctions.getDate(data.updateDt);
        this.quoteDate = DateFunctions.getDate(data.quoteDate);
    }
    relatedJobId: any;
    companyId: any;
    dispatchId: any;
    relatedJobTypeId: any;
    masterJobId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    relatedJobTypeName: string;
    dispatchNumber: string;
    dispatchReason: string;
    totalLaborCosts: number;
    totalMatCosts: number;
    totalLaborValue: number;
    totalMatValue: number;
    quoteId: any;
    quoteDesc: string;
    quoteNumber: string;
    totalQuote: number;
    totalOtherCosts: number;
    get totalCosts(): number {
        return this.totalLaborCosts + this.totalMatCosts + this.totalOtherCosts;
    }
    set totalCosts(value: number) {

    }
    quoteStatusId: any;
    quoteStatusName: string;
    isPassThrough: boolean;
    dispatchStatusName: string;
    accountClassName: string;
    jobStatus: string;
    crNum: string;
    coNum: string;
    changeOrderInfo: string;
    changeReqInfo: string;
    totalQuoteCost: number;
    invoiceId: any;
    invoiceNumber: string;
    invTotal: number;
    accountClassId: any;
    quoteDate: Date;
    quoteStatusDate: Date;
}
